var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list_gridOptions)?_c('vxe-grid',_vm._b({ref:_vm.ref,on:{"toolbar-button-click":_vm.list_toolbarButtonClickEvent}},'vxe-grid',_vm.list_gridOptions,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }